import { createEnvelopeSource } from './create-envelope-source';

export const paymentMethodsAddedSource = createEnvelopeSource({
    label: 'New payment methods',
    endpoint: 'analytics/payment-methods-added',
    metrics: [
        {
            id: 'paymentMethodsAdded',
            label: 'New payment methods',
            type: 'scalar',
        },
    ],
    forms: ['number'],
    regionGrain: 'brand',
});
